// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"5":"vendor-chart.js","394":"vendor-moment","603":"vendor-monaco-editor","695":"vendor-xlsx","725":"vendor-highlight.js","894":"vendor-gridstack"}[chunkId] || chunkId) + ".millennium.js";
};